import React from 'react';
import { DataConsistencyDTO } from 'types/dataConsistency';
import { MnemonicsMappingDTO } from 'types/mnemonicsMapping';

import styles from './DataConsistency.module.scss';
import TrajectoryCheck from './TrajectoryCheck';
import BoosterCheck from '../BoosterCheck';
import ChromatographyCheck from '../ChromatographyCheck';
import DepthCheck from '../DepthCheck';
import FlowCorrelation from '../FlowCorrelation';

interface Props {
  dataConsistency?: DataConsistencyDTO;
  locationType?: string;
  isFlowinBstNa: boolean;
  mnemonicsMapping?: MnemonicsMappingDTO;
}

const DataConsistency: React.FC<Props> = ({
  dataConsistency,
  locationType,
  isFlowinBstNa,
  mnemonicsMapping,
}) => {
  return (
    <div className={styles.dataConsistency}>
      <FlowCorrelation flowCorrelation={dataConsistency?.flowCorrelation} />
      <BoosterCheck
        locationType={locationType}
        isFlowinBstNa={isFlowinBstNa}
        mnemonicsMapping={mnemonicsMapping}
      />
      <TrajectoryCheck
        trajectoryRate={dataConsistency?.trajectoryRate}
        trajectoryMax={dataConsistency?.trajectoryMax}
      />
      <DepthCheck
        depthOutliers={dataConsistency?.depthOutliers}
        bitdepOutliers={dataConsistency?.bitdepOutliers}
      />
      <ChromatographyCheck mnemonicsMapping={mnemonicsMapping} />
    </div>
  );
};

export default DataConsistency;
